module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "random-episode"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.getRandomEpisode
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('episode', {
    attrs: {
      "episode": _vm.episode
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-655e3ed4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomEpisode.vue
// module id = 41
// module chunks = 0